module.exports = __webpack_public_path__ + "img/lb.71e18bef.svg";